class FileDownload {
    constructor(){}

    /*
    download(base64, fileName, fileType) {
        //const val = this.base64ToArrayBuffer(base64);
        this.saveByteArray(fileName, base64, fileType);
    }
    downloadByBlobUrl(blobUrl, fileName){
        const link = document.createElement('a');
        link.href = blobUrl
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
    blobUrl(base64, fileType){
        const val = this.base64ToArrayBuffer(base64);
        var blob = new Blob([val], {type: fileType});
        return window.URL.createObjectURL(blob);
    }
    base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }
    saveByteArray(reportName, byte, fileType) {
        var link = document.createElement('a');
        link.href = this.blobUrl(byte, fileType);
        var fileName = reportName;
        link.download = fileName;
        link.click();
    }
    */
    download(blobUrl, fileName){
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
    downloadBase64(base64, fileName, fileType){
        const data = this.base64ToArrayBuffer(base64);
        const blobUrl = this.getBlobUrl(data, fileType);
        this.download(blobUrl, fileName);
    }
    getBlob(data, fileType){
        const blob = new Blob([data], {type:fileType})
        return blob;
    }
    getBlobUrl(data, fileType){
        return window.URL.createObjectURL(this.getBlob(data, fileType));
    }
    base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    /*
    base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }
    saveByteArray(reportName, byte, fileType) {
        var link = document.createElement('a');
        link.href = this.getBlobUrl(byte, fileType);
        var fileName = reportName;
        link.download = fileName;
        link.click();
    }
    */
   






}

export default FileDownload;